import React, { memo } from 'react'

import CardBody from '../../../UI/Card/Body/Body'
import StructureCard from './StructureCard/StructureCard'
import Collapse from '../../../../components/UI/Collapse/Collapse'

const appraisalItemBody = ({
  recordKey,
  adding,
  editing,
  deleting,
  structureData,
  loading,
  addDisabled,
  editDisabled,
  deleteDisabled,
  collap,
  collapseCheck,
  open
}) => {
  let structureCards = structureData.map(structureItem => {
    const structureId = structureItem.structure_id
    const structureGetZero = structureItem.is_get_zero
    let collapp = open.find(item => item.structure_id === structureId)
    if (collapp.structure_id === collapseCheck) {
      collapp.open = true
    }

    const structureType = structureItem.structure_type.value_list_code
    let children = (
      <StructureCard
        key={structureItem.structure_id}
        structureKey={structureItem.structure_id}
        structureData={structureItem}
        structureType={structureType}
        adding={() => adding(structureId, structureType, structureGetZero)}
        editing={recordId => editing(recordId, structureId, structureType, structureGetZero)}
        deleting={deleting}
        recordKey={recordKey}
        loading={loading}
        addDisabled={addDisabled}
        editDisabled={editDisabled}
        deleteDisabled={deleteDisabled}
      />
    )

    return (
      <Collapse
        key={structureId}
        title={structureItem.structure_name}
        show={collapp.open}
        toggleBarClicked={() => collap(structureId)}
        children={children}></Collapse>
    )
  })

  let appraisalItemBody = <CardBody>{structureCards}</CardBody>

  return appraisalItemBody
}

export default memo(appraisalItemBody)
